import React from 'react';
import Navbar from './Navbar';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Navbar />
      <main className="flex-1 max-w-7xl w-full mx-auto px-4 py-6">
        {children}
      </main>
      <footer className="border-t border-gray-200 py-3 text-center text-xs text-gray-400">
        Edudeploy — Tous droits réservés
      </footer>
    </div>
  );
}
